import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AuthContext from "../Context/AuthProvider";
import { getFacilityUsers } from "../API/UsersApi";
import { getClinicalServices } from "../API/FacilitySettingsApi";
import { VisitTypes } from "../Utility/Constants";
import SchedulingAssistant from "./SchedulingAssistant";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { convertToUTC, convertUTCToTimeZone } from "../Utility/DateTimeUtility";
import { changeAppointment, changeVisit, createNewVisit, getVisit } from "../API/VisitsApi";
import { toBeChecked } from "@testing-library/jest-dom/matchers";
import { showLoadingImage } from "../Utility/Utility";
import { useSnackbar } from "../Utility/UserMessageContext";

const EditVisit = ({visit, closeTab }) => {
  const { showSnackbar } = useSnackbar();
  const [selectedPatient, setSelectedPatient] = useState();
  const [availablePhysicians, setAvailablePhysicians] = useState();
  const { auth } = useContext(AuthContext);
  const [patientNotes, setPatientNotes] = useState();
  const [availableServices, setAvailableServices] = useState();
  const [selectedServiceId, setSelectedServiceId] = useState();
  const [selectedPhysicianId, setSelectedPhysicianId] = useState();
  const [selectedService, setSelectedService] = useState("");
  const [selectedPhysician, setSelectedPhysician] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [scheduledFrom, setScheduledFrom] = useState();
  const [scheduledTo, setScheduledTo] = useState();
  const [scheduledStartDateTime, setScheduledStartDateTime] = useState();
  const [scheduledEndDateTime, setScheduledEndDateTime] = useState();
  const [onwardTravelTimeInMins, setOnwardTravelTimeInMins] = useState(0);
  const [returnTravelTimeInMins, setReturnTravelTimeInMins] = useState(0);
  const [addingVisit, setAddingVisit] = useState(false);
  const [dataRestored, setDataRestored] = useState(false);

  useEffect(() => {
    const getPhysicians = async () => {
      var result = await getFacilityUsers(auth, {
        facilityId: auth.selectedFacility.id,
        roles: ["Physician"],
      });
      if (result?.isSuccess) {
        setAvailablePhysicians(result?.data);
      }
    };

    const setClinicalServices = async () => {
      const filters = {
        facilityId: auth.selectedFacility.id,
        visitType: visit?.currentVisitType,
      };
      var result = await getClinicalServices(auth, filters);
      if (result.isSuccess) {
        console.log(result?.data);
        setAvailableServices(result?.data);
      } else {
        showSnackbar("Error occurred while fetching clinical services.","error");
      }
    };

    

    const restoreData = () => {
      const savedNewVisit = localStorage.getItem(visit?.id);

      if (savedNewVisit) {
        const savedNewVisitJSON = JSON.parse(savedNewVisit);
        if (savedNewVisitJSON) {
          //setSelectedPatient(savedNewVisitJSON.selectedPatient);
          setSelectedPhysicianId(savedNewVisitJSON.selectedPhysicianId);
          setSelectedServiceId(savedNewVisitJSON.selectedServiceId);
          setPatientNotes(savedNewVisitJSON.patientNotes);
        }
      }
      setDataRestored(true);
    };

    setDataRestored(false);
    setClinicalServices();
    getPhysicians();
    //restoreData();
  }, [auth, visit]);

  useEffect(() => {
    const loadVisitDetails = async () => {
      //const result = await getVisit(auth, visitId);
      if (visit && availablePhysicians && availableServices && auth) {
        //setSelectedPatient(result?.data?.patient);
        setSelectedPhysicianId(visit.physicianId);
        setSelectedServiceId(visit.primaryClinicalServiceId);
        setSelectedPhysician(visit.physician);
        setSelectedService(visit.service);
        setSelectedDate(convertUTCToTimeZone(visit.scheduledStartDateTime, auth?.selectedFacility?.timeZone));
        setScheduledFrom(convertUTCToTimeZone(visit.scheduledStartDateTime,auth?.selectedFacility?.timeZone));
        setScheduledTo(convertUTCToTimeZone(visit.scheduledEndDateTime, auth?.selectedFacility?.timeZone));
        // setScheduledStartDateTime(convertUTCToTimeZone(visit.scheduledStartDateTime, auth?.selectedFacility?.timeZone));
        // setScheduledEndDateTime(convertUTCToTimeZone(visit.scheduledEndDateTime, auth?.selectedFacility?.timeZone));
        setPatientNotes(visit.notes);
        setOnwardTravelTimeInMins(visit.onwardTravelTimeInMins);
        setReturnTravelTimeInMins(visit.returnTravelTimeInMins);
      }
    }
    loadVisitDetails();
  }, [availablePhysicians, availableServices, visit, auth])

 const onScheduledDateTimeChange = (choosenDate, fromTime, toTime) => {
  if(choosenDate && fromTime && toTime) {
    const startDateTime = dayjs(choosenDate).set("hour", fromTime.hour()).set("minute", fromTime.minute());
    const endDateTime = dayjs(choosenDate).set("hour", toTime.hour()).set("minute", toTime.minute());
    if(!endDateTime.isAfter(startDateTime)) {
      showSnackbar("End date time should be after start date time.", "error");
      return;
    }
    setScheduledStartDateTime(startDateTime);
    setScheduledEndDateTime(endDateTime);
  }
 }

  const saveVisit = async () => {
      setAddingVisit(true);
      //e.preventDefault();
      // const physicianId = document.querySelector("#physicianSelector").value;
      // const serviceId = document.querySelector("#serviceSelector").value;
      const result = await changeVisit(
        auth,
        visit?.id,
        convertToUTC(scheduledStartDateTime),
        convertToUTC(scheduledEndDateTime),
        patientNotes,
        selectedServiceId,
        selectedPhysicianId,
        onwardTravelTimeInMins,
        returnTravelTimeInMins,
      );
      if (result.isSuccess) {
        showSnackbar("Visit created successfully.","success");
        closeTab(visit?.id);
      } else {
        showSnackbar("Error occurred while creating the visit.","error");
      }
      setAddingVisit(false);
    };

  return (
    <Grid2 container>
      <Grid2 container size={12} sx={{padding: 2 }}>
        <Grid2
          container
          size={12}
          spacing={2}
          sx={{ justifyContent: "start", alignItems: "center" }}
        >
          <Tooltip title="Save Visit" arrow>
            <Button
              variant="contained"
              color="secondary"
              onClick={saveVisit}
              size="medium"
              disabled={addingVisit || !selectedPhysicianId || !selectedServiceId || !scheduledStartDateTime || !scheduledEndDateTime}
              //startIcon={<AddRoundedIcon fontSize="small" />}
            >
              Save Visit
            </Button>
          </Tooltip>
        </Grid2>
      </Grid2>
      <Grid2
        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 6 }}
        container
        spacing={2}
        sx={{ paddingX: 2 }}
      >
        <Card variant="outlined">
          <Grid2 size={12} container spacing={2} sx={{ padding: 2 }}>
            <Grid2 container size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <Grid2 size={12} item>
                <Typography variant="h6" gutterBottom>
                  Patient - {visit?.patientPrefix} {visit?.patientFirstName} {visit?.patientLastName}
                  </Typography>
              </Grid2>
              <Grid2 container size={12} item>
                <Grid2 container size={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Primary Service
                    </InputLabel>
                    <Select
                      label="Primary Service"
                      value={selectedServiceId}
                      disabled={addingVisit}
                      onChange={(e) => {
                        setSelectedServiceId(e.target.value);
                        setSelectedService(
                          availableServices.find((s) => s.id === e.target.value)
                        );
                      }}
                    >
                      {availableServices &&
                        availableServices?.map((s) => (
                          <MenuItem value={s.id}>
                            {s.name}, Fees Rs. {s.fees}, Duration{" "}
                            {s.durationInMins} Mins
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 container size={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Physician
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedPhysicianId}
                      label="Physician"
                      disabled={addingVisit}
                      onChange={(e) => {
                        setSelectedPhysicianId(e.target.value);
                        setSelectedPhysician(
                          availablePhysicians.find(
                            (p) => p.id === e.target.value
                          )
                        );
                      }}
                    >
                      {availablePhysicians &&
                        availablePhysicians?.map((p) => (
                          <MenuItem value={p.id}>
                            {p.salutation} {p.firstName} {p.lastName},{" "}
                            {p.suffix}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid2>
              </Grid2>
              {visit?.currentVisitType === VisitTypes.Home && (
                <Fragment>
                <Grid2 size={6}>
                  <FormControl fullWidth>
                    <InputLabel>Travel Time (Onward)</InputLabel>
                    <Select
                      value={onwardTravelTimeInMins}
                      disabled={addingVisit}
                      onChange={(e) => {
                        setOnwardTravelTimeInMins(e.target.value);
                      }}
                      label="Travel Time (Onward)"
                    >
                      {[...Array(12)].map((_, index) => {
                        const minutes = (index + 1) * 5;
                        return (
                          <MenuItem key={minutes} value={minutes}>
                            {minutes} mins
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 size={6}>
                <FormControl fullWidth>
                  <InputLabel>Travel Time (Return)</InputLabel>
                  <Select
                    value={returnTravelTimeInMins}
                    disabled={addingVisit}
                    onChange={(e) => {
                      setReturnTravelTimeInMins(e.target.value);
                    }}
                    label="Travel Time (Return)"
                  >
                    {[...Array(12)].map((_, index) => {
                      const minutes = (index + 1) * 5;
                      return (
                        <MenuItem key={minutes} value={minutes}>
                          {minutes} mins
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid2>
              </Fragment>
              )}
              <Grid2 size={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Visit Date"
                    sx={{ width: "100%" }}
                    // minDate={dayjs(new Date())}
                    value={selectedDate}
                    disabled={addingVisit}
                    onChange={(value) => {
                      setSelectedDate(value);
                      onScheduledDateTimeChange(value, scheduledFrom, scheduledTo);}}
                  />
                </LocalizationProvider>
              </Grid2>
              <Grid2 size={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker label="From" value={scheduledFrom} disabled={addingVisit} onChange={(value) => {
                  setScheduledFrom(value);
                  setScheduledTo(value?.add(selectedService.durationInMins, "minute"));
                  onScheduledDateTimeChange(selectedDate, value, value?.add(selectedService.durationInMins, "minute"));
                }}></TimePicker>
                </LocalizationProvider>
              </Grid2>

              <Grid2 size={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker label="To" value={scheduledTo} disabled={addingVisit} minTime={scheduledFrom} onChange={(value) => {
                setScheduledTo(value);
                onScheduledDateTimeChange(selectedDate, scheduledFrom, value);
              }}></TimePicker>
                </LocalizationProvider>
              </Grid2>
              <Grid2 container size={12}>
                <TextField
                  fullWidth
                  label="Notes"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  value={patientNotes}
                  multiline
                  minRows={3}
                  maxRows={3}
                  disabled={addingVisit}
                  onChange={(e) => {
                    setPatientNotes(e.target.value);
                  }}
                ></TextField>
              </Grid2>
            </Grid2>
            <Grid2 container size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <SchedulingAssistant
                physician={selectedPhysician}
                selectedDate={selectedDate}
                newSlot={{from: scheduledFrom, to: scheduledTo, new: true, title: "Edit Visit", onwardTravelTime: onwardTravelTimeInMins, returnTravelTime: returnTravelTimeInMins}} 
              />
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default EditVisit;
